import { useEffect } from 'react';

export const useInstagramEmbeddingsProcessing = instgrm => {
  useEffect(() => {
    instgrm?.Embeds.process();
  }, [instgrm]);
};
